import { Component, Input } from '@angular/core';
import { Controller } from 'src/app/core/models/controller.model';
import { Property } from 'src/app/core/models/project/property.model';

@Component({
  selector: 'app-modal-view-window-prop',
  templateUrl: './modal-view-window-prop.component.html',
  styleUrl: './modal-view-window-prop.component.scss'
})
export class ModalViewWindowPropComponent {
   @Input({required: true}) controllers: Controller[];
    @Input({required: true}) propFilterFunction: (property: Property) => boolean
    @Input({required: true}) activeSufix: string ;
    @Input({required: true}) inactiveSufix: string;
    @Input({required: true}) iconActive: string;
    @Input({required: true}) iconInactive: string;
    @Input({required: true}) forcePropIndex: number;

    Property = Property;

    constructor() {}

    ngOnInit(): void {}

}


